// EXTERNAL
import React, { useState, useLayoutEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

// INTERNAL
import InlineBodyText from 'components/atoms/inline-body-text'
import NewToolTip from 'components/atoms/new-tooltip'

const StyledBodyText = styled(InlineBodyText)`
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`

const StyledBodyTextWithBorder = styled(InlineBodyText)`
  display: block;
  border-bottom: dashed 1px ${({ theme }) => theme.colors.brandBravo};
  min-width: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`

const StyledDiv = styled('div')`
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  min-width: 0;
  width: 100%;

  > div {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
  }
`

const OverflowingTextWithToolTip = ({ text }) => {
  const spanRef = useRef()
  const [isEllipsisActive, setIsEllipsisActive] = useState(false)

  useLayoutEffect(() => {
    const { current: span } = spanRef
    const updateEllipsisState = () => {
      setIsEllipsisActive(span.scrollWidth > span.clientWidth)
    }
    const resizeObserver = new ResizeObserver(updateEllipsisState)

    updateEllipsisState()
    resizeObserver.observe(span)

    return () => resizeObserver.disconnect()
  }, [text])

  return (
    <StyledDiv ref={spanRef}>
      {isEllipsisActive ? (
        <NewToolTip title={text} placement="right" arrow width={260}>
          <StyledBodyTextWithBorder>{text}</StyledBodyTextWithBorder>
        </NewToolTip>
      ) : (
        <StyledBodyText>{text}</StyledBodyText>
      )}
    </StyledDiv>
  )
}

OverflowingTextWithToolTip.propTypes = {
  text: PropTypes.string.isRequired,
}

export default OverflowingTextWithToolTip
